/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import { animateScroll as scroll } from "react-scroll";
import { toast } from 'react-toastify'; //토스트(toast)
import { dropByCacheKey } from 'react-router-cache-route';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
import moment from 'moment';
class QuickMenu extends PureComponent {
  state = {
    show: false,
  };
  componentDidMount = () => {
    const { quickMenu, history } = this.props;

    this.setState({
      show: false,
    });
  };
  _event = () => {
    const { history } = this.props;

    history.push('/event');
  };
  _card = () => {
    const { setCardListShow, loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      setCardListShow(true);
    }
  };
  _update = () => {
    const { setUpdateShow } = this.props;
    setUpdateShow(true);
  };
  _zzim = () => {
    const { history, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      history.push('/mypage/0');
    }
  };
  _friend = () => {
    const { setShowFriend, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      setShowFriend(true);
    }
  };
  _change = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onLogout = () => {
    const { setLoginId, setAuthId, history } = this.props;

    this.setCookie('account', '');
    this.setCookie('ad', '');
    this.setCookie('at', '');
    this.setCookie('rt', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    toast.success('정상적으로 로그아웃 되었습니다.');
    window.scrollTo(0, 0);
    dropByCacheKey('main');
    //clearCache()
    window.location.replace('/');
    //setTimeout(()=>{
    //    history.push('/')
    //}, 700)
  };
  _login = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);
    history.push('/login');
  };
  _customer = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);
    history.push('/customer/1');
  };
  _alram = () => {
    const { history, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      window.scrollTo(0, 0);
      history.push('/mypage/10');
    }
  };
  _onTop = () => {
    window.scrollTo(0, 0);
  };

  render() {
    const { show } = this.state;
    const { loginId, history, imgUrl, serviceEndDate } = this.props;

    //history.location.pathname.indexOf('/store')
    return (
      <Fragment>
        <input
          type="checkbox"
          id="quickMenu"
          checked={show}
          onChange={this._change}
        />
        <div className="quick">
          <label htmlFor="quickMenu" className="btn_quick" title="Quick menu">
            <i></i>
          </label>
          <div className="tit">
            <span>
              Quick
              <br />
              menu
            </span>
          </div>
          <ul className="quick_menu">
            {history.location.pathname.indexOf('/store') > -1 ||
            history.location.pathname.indexOf('/story') > -1 ? (
              <Fragment>
                <li>
                  <a onClick={this._customer} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/theme_light/ico_customer.png'} />
                    고객센터
                  </a>
                  {/*<!-- 신규 있을 때 className="new" -->*/}
                </li>
                <li>
                  <a onClick={this._event} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/theme_light/ico_event.png'} />
                    이벤트
                  </a>
                </li>
                {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <li>
                    <a onClick={this._update} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/theme_light/ico_update.png'} />
                      주간업데이트
                    </a>
                  </li>
                )}
                <li>
                  <a onClick={this._card} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/theme_light/ico_cashcard.png'} />
                    포인트카드
                  </a>
                </li>
                {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <>
                    <li>
                      <a onClick={this._zzim} style={{ cursor: 'pointer' }}>
                        <img src={imgUrl + '/img/theme_light/ico_heart3.png'} />
                        보관함
                      </a>
                    </li>
                    <li>
                      <a onClick={this._friend} style={{ cursor: 'pointer' }}>
                        <img
                          src={imgUrl + '/img/theme_light/ico_friendplus.png'}
                        />
                        친구추가
                      </a>
                    </li>

                    <li>
                      <a onClick={this._alram} style={{ cursor: 'pointer' }}>
                        <img src={imgUrl + '/img/theme_light/ico_bell.png'} />
                        알림
                      </a>
                    </li>
                  </>
                )}

                {/*
                            <li>
                                <a href="#" className="link_plus"><img src="/img/theme_light/ico_plus.png"/>추가</a>
                            </li>
                            */}
                {loginId === null || loginId === undefined || loginId === '' ? (
                  <li>
                    <a onClick={this._login} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/common/ico_login.png'} />
                      로그인
                    </a>
                  </li>
                ) : (
                  <li>
                    <a onClick={this._onLogout} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/common/ico_logout.png'} />
                      로그아웃
                    </a>
                  </li>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <li>
                  <a
                    className=""
                    onClick={this._customer}
                    style={{ cursor: 'pointer' }}
                  >
                    <img src={imgUrl + '/img/common/ico_customer.png'} />
                    고객센터
                  </a>
                </li>
                <li>
                  <a onClick={this._event} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/common/ico_event.png'} />
                    이벤트
                  </a>
                </li>
                {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <li>
                    <a onClick={this._update} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/common/ico_update.png'} />
                      주간업데이트
                    </a>
                  </li>
                )}
                <li>
                  <a onClick={this._card} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/common/ico_cashcard.png'} />
                    포인트카드
                  </a>
                </li>
                {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <>
                    <li>
                      <a onClick={this._zzim} style={{ cursor: 'pointer' }}>
                        <img src={imgUrl + '/img/common/ico_heart3.png'} />
                        보관함
                      </a>
                    </li>
                    <li>
                      <a onClick={this._friend} style={{ cursor: 'pointer' }}>
                        <img src={imgUrl + '/img/common/ico_friendplus.png'} />
                        친구추가
                      </a>
                    </li>
                    <li>
                      <a onClick={this._alram} style={{ cursor: 'pointer' }}>
                        <img src={imgUrl + '/img/common/ico_bell.png'} />
                        알림
                      </a>
                    </li>
                  </>
                )}

                {loginId === null || loginId === undefined || loginId === '' ? (
                  <li>
                    <a onClick={this._login} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/common/ico_login.png'} />
                      로그인
                    </a>
                  </li>
                ) : (
                  <li>
                    <a onClick={this._onLogout} style={{ cursor: 'pointer' }}>
                      <img src={imgUrl + '/img/common/ico_logout.png'} />
                      로그아웃
                    </a>
                  </li>
                )}
              </Fragment>
            )}
          </ul>
          {isMobile ? null : (
            <button
              type="button"
              className="top"
              title="Top"
              onClick={this._onTop}
            >
              top
            </button>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(QuickMenu)));
